import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../../components/Modal";
import { Formik } from "formik";
import { Center } from "../../../../../../components/StyledComponents";
import {
  initialValues,
  schema,
} from "../../../../../../constants/form/recruiting/technolgies/edit";
import techActions from "../../../../../../store/actions/recruiting/index";
import Grid from "../../../../../../components/Grid";
import Button from "../../../../../../components/Button";
import Submit from "../../../../../../components/Form/Submit";
import { toast } from "react-toastify";
import TextArea from "../../../../../../components/Form/TextArea";
import Input from "../../../../../../components/Form/Input";
import { useRecruitingLayout } from "../../../../../../provider/RecruitingProvider";
import { hideModal } from "../../../../../../store/actions/modal";
interface ComponentProps {
  updateStates: {
    loading: boolean;
    error: boolean | string;
    success: boolean;
  };
}

const Component = ({ updateStates }: ComponentProps) => {
  const { selectedItem } = useRecruitingLayout();
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();

  const dispatch = useDispatch();

  const onSubmit = ({ values, actions }) => {
    dispatch(techActions.technology.update(values));
    setFormActions(actions);
  };

  useEffect(() => {
    if (updateStates.success) {
      toast("👌🏼 Tecnología editada correctamente", {
        containerId: "submit",
        type: "success",
        toastId: "submitsucceful",
      });

      setTimeout(() => {
        dispatch(techActions.technology.resetUpdate());
        dispatch(hideModal());
        formActions?.resetForm();
      }, 1000);
    }

    if (updateStates.error) {
      toast(`😱 ${updateStates.error}`, {
        containerId: "submit",
        type: "error",
        toastId: "submiterror",
      });

      setTimeout(() => {
        dispatch(techActions.technology.resetUpdate());
      }, 1000);
    }
  }, [updateStates]);
  return (
    <Modal name="edit-techbology-modal" title="Editar Tecnología">
      <Formik
        initialValues={{ ...initialValues(selectedItem?.data) }}
        onSubmit={(values, actions) => {
          if (onSubmit) onSubmit({ values, actions });
        }}
        validateOnChange={formSubmmited}
        validateOnBlur={false}
        validationSchema={schema}
        enableReinitialize
      >
        {({
          touched,
          errors,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
          isSubmitting,
        }) => {
          return (
            <form
              className="theme-form"
              onSubmit={(event) => {
                setFormSubmmited(true);
                handleSubmit(event);
              }}
              id="new-evaluate-form"
            >
              <Grid.Row>
                <Grid.Col>
                  <Input
                    name={"name"}
                    error={errors["name"]}
                    touched={touched["name"]}
                    value={values["name"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={{ label: "Tecnologia*", skin: "gray" }}
                  />
                </Grid.Col>
                <TextArea
                  name="description"
                  error={errors["description"]}
                  touched={touched["description"]}
                  value={values["description"]}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  options={{
                    label: "Descripcion",
                    marginBottom: 24,
                    skin: "gray",
                  }}
                />
              </Grid.Row>

              <Grid.Row>
                <Grid.Col>
                  <Center gap={"70px"}>
                    <Button
                      onClick={resetForm}
                      type="button"
                      options={{
                        type: "outline",
                        skin: "gray",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                      style={{ marginLeft: "10px" }}
                    >
                      Cancelar
                    </Button>

                    <Submit
                      isSubmmiting={isSubmitting}
                      form="new-evaluate-form"
                      color="Primary"
                      options={{
                        type: "filled",
                        skin: "primary",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                    >
                      Confirmar
                    </Submit>
                  </Center>
                </Grid.Col>
              </Grid.Row>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};

const states = ({ recruitingStore }) => {
  const { states: updateStates } = recruitingStore.technology.update;
  return {
    updateStates,
  };
};
export default connect(states)(Component);
